import { Box, Grid, Image, Text } from "@mantine/core";
import { useSelector } from "react-redux";
import Background from "../../src/assets/background-blur.svg";
import { GridCard } from "../components/home/card";
import Layout from "../components/home/layout";
import { navigationData } from "../constants/navigation";
import { hasPermissionCode } from "../utils/permission";
import { IAuth } from "../interfaces/IAuth";
import { useIsTenantAdmin } from "../hooks/useIsTenantAdmin";
import classes from "./homepage.module.css";

export default function Homepage() {
  const { user } = useSelector((state: { auth: IAuth }) => state.auth);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const permissions = useSelector((state: any) => state.general?.permissions ?? []);
  const isTenantAdmin = useIsTenantAdmin();

  return (
    <Layout>
      <Image className={classes.background} src={Background} />
      <Box className={classes.container}>
        <Box className={classes.row}>
          <Box>
            <Text fz={"lg"} c={"white"}>
              Сайн байна уу!
            </Text>
            <Text className={classes.text}>
              {user?.lastName && `${user?.lastName}.`}
              {user?.firstName}
            </Text>
            <Box className={classes.description}>
              Та DeHUB платформын Back Office-д амжилттай нэвтэрлээ! Энэ нь DeHUB платформд бүртгэлтэй компаниудын бүртгэл, хяналт, гэрээний харилцаа болон
              админ эрхийн тохиргоо хийх, платформ дээр ашиглагдах лавлах мэдээллүүдийг бүртгэх, тохируулах, дотоод хэрэглэгчдийн бүртгэл, эрхийн тохиргоо
              зэргийг хийх зориулалттай тул зааврын дагуу нягт нямбай, өндөр хариуцлагатай ажиллана уу.
            </Box>
          </Box>
        </Box>
        <Grid className={classes.grid} gap={48}>
          {navigationData
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .filter((d: any) => (isTenantAdmin ? d.audience === "TENANT" : d.audience !== "TENANT"))
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .filter((d: any) => hasPermissionCode(permissions, d.requiredPermission))
            .map((data: any, index: number) => (
              <Grid.Col span={{ xs: 12, sm: 6, lg: 4 }} key={index}>
                <GridCard data={data} />
              </Grid.Col>
            ))}
        </Grid>
      </Box>
    </Layout>
  );
}
